import styled from 'styled-components';

export const NavigatorContainer = styled.div`
  display: flex;
  height: 56px;
  width: 100%;
  padding: 0 16px;
  gap: 16px;
  align-items: center;
  box-shadow: 0 2px 2px 0 #00000014;
`;

export const NavigatorImg = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
